<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <privacyBanner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import privacyBannerComponent from '../privacy/privacyBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    privacyBannerComponent,
    footerComponent,
  },
};
</script>
